<template>
  <div v-show="showBox" :class="mode == 'pop' ? 'mask' : ''">
    <div
      :class="mode == 'pop' ? 'verifybox' : ''"
      :style="{ 'max-width': parseInt(imgSize.width) + 30 + 'px' }"
    >
      <div v-if="mode == 'pop'" class="verifybox-top">
        {{ $t('membership.dialog.verifyTitle') }}
        <span class="verifybox-close" @click="closeBox">
          <i class="iconfont icon-close" />
        </span>
      </div>
      <div
        class="verifybox-bottom"
        :style="{ padding: mode == 'pop' ? '15px' : '0' }"
      >
        <component
          :is="componentType"
          v-if="componentType"
          ref="instance"
          :captcha-type="captchaType"
          :type="verifyType"
          :figure="figure"
          :arith="arith"
          :mode="mode"
          :v-space="vSpace"
          :explain="explain"
          :img-size="imgSize"
          :block-size="blockSize"
          :bar-size="barSize"
          :show-type="showType"
        />
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  /**
   * Verify 验证码组件
   * @description 分发验证码使用
   * */
  import VerifySlide from './VerifySlide.vue'
  import VerifyPoints from './VerifyPoints.vue'
  import { computed, ref, watch, toRefs, watchEffect, onMounted } from 'vue'

  export default {
    name: 'Verify2', // 修改组件名为 Verify2 以匹配引用
    components: {
      VerifySlide,
      VerifyPoints,
    },
    props: {
      visible: {
        type: Boolean,
        default: undefined,
      },
      captchaType: {
        type: String,
        required: true,
      },
      figure: {
        type: Number,
      },
      arith: {
        type: Number,
      },
      mode: {
        type: String,
        default: 'pop',
      },
      vSpace: {
        type: Number,
      },
      explain: {
        type: String,
      },
      imgSize: {
        type: Object,
        default() {
          return {
            width: '310px',
            height: '155px',
          }
        },
      },
      blockSize: {
        type: Object,
        default() {
          return {
            width: '50px',
            height: '50px',
          }
        },
      },
      barSize: {
        type: Object,
        default() {
          return {
            width: '310px',
            height: '40px',
          }
        },
      },
      showType: {
        type: String,
        default: '',
      }
    },
    setup(props, { emit }) {
      const {
        visible,
        captchaType,
        figure,
        arith,
        mode,
        vSpace,
        explain,
        imgSize,
        blockSize,
        barSize,
        showType
      } = toRefs(props)
      const clickShow = ref(false)
      const verifyType = ref(undefined)
      const componentType = ref(undefined)

      const instance = ref({})

      const showBox = computed(() => {
        if (mode.value == 'pop') {
          return clickShow.value
        } else {
          return true
        }
      })
      /**
       * refresh
       * @description 刷新
       * */
      const refresh = () => {
        console.log(instance.value)
        if (instance.value.refresh) {
          instance.value.refresh()
        }
      }
      const closeBox = () => {
        clickShow.value = false
        // 触发 update:visible 事件，支持 .sync 修饰符
        emit('update:visible', false)
      }

      // 监听 visible prop 变化，支持外部控制显示
      // 使用 watchEffect 而不是 watch，以确保正确追踪响应式变化
      watchEffect(() => {
        const val = visible.value
        if (val !== undefined) {
          clickShow.value = val
          if (val) {
            refresh()
          }
        }
      })

      const show = () => {
        if (mode.value == 'pop') {
          clickShow.value = true
          refresh()
        }
      }

      function generateUUID() {
        const s = [];
        const hexDigits = '0123456789abcdef';

        for (let i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }

        s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((parseInt(s[19], 16) & 0x3) | 0x8, 1); // 修正位运算
        s[8] = s[13] = s[18] = s[23] = '-';

        const slider = `slider-${s.join('')}`;
        const point = `point-${s.join('')}`;

        // 判断是否存在 slider / point
        // console.log(localStorage.getItem('slider'));

        if (!localStorage.getItem('slider')) {
          localStorage.setItem('slider', slider);
        }

        if (!localStorage.getItem('point')) {
          localStorage.setItem('point', point);
        }
      }

      onMounted(() => {
        generateUUID();
      });
      watchEffect(() => {
        switch (captchaType.value) {
          case 'blockPuzzle':
            verifyType.value = '2'
            componentType.value = 'VerifySlide'
            break
          case 'clickWord':
            verifyType.value = ''
            componentType.value = 'VerifyPoints'
            break
        }
      })

      return {
        clickShow,
        verifyType,
        componentType,
        instance,
        showBox,
        closeBox,
        show,
      }
    },
  }
</script>
<style>
  .verifybox {
    position: relative;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #e4e7eb;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: fixed; /* 修正: H5中居中弹窗建议使用fixed */
    z-index: 2000;
  }
  .verifybox-top {
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-size: 16px;
    color: #45494c;
    border-bottom: 1px solid #e4e7eb;
    box-sizing: border-box;
  }
  .verifybox-bottom {
    padding: 15px;
    box-sizing: border-box;
  }
  .verifybox-close {
    position: absolute;
    top: 13px;
    right: 9px;
    width: 24px;
    height: 24px;
    text-align: center;
    cursor: pointer;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    /* display: none; */
    transition: all 0.5s;
  }
  .verify-tips {
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
  }
  .suc-bg {
    background-color: rgba(92, 184, 92, 0.5);
  }
  .err-bg {
    background-color: rgba(217, 83, 79, 0.5);
  }
  .tips-enter,
  .tips-leave-to {
    bottom: -30px;
  }
  .tips-enter-active,
  .tips-leave-active {
    transition: bottom 0.5s;
  }
</style>